import { render, staticRenderFns } from "./CopyQrCodeString.vue?vue&type=template&id=35f89e0c&scoped=true"
import script from "./CopyQrCodeString.vue?vue&type=script&lang=js"
export * from "./CopyQrCodeString.vue?vue&type=script&lang=js"
import style0 from "./CopyQrCodeString.vue?vue&type=style&index=0&id=35f89e0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f89e0c",
  null
  
)

export default component.exports